import { useMemo } from 'react';

import { useCompanies, useRoles, useUsers } from '@adsk/alloy-provider';

import useUsersPermissionInfo from './useUsersPermissionInfo';
import { useFormsContext } from '../FormsProvider';

const useEntitiesMap = (
  useResource,
  mapKey,
  dataKey = 'data',
  loadingKey = 'loading',
) => {
  const { [dataKey]: data, [loadingKey]: loading } = useResource();
  return useMemo(() => {
    if (loading || !data || !data.filter) {
      return { data, loading };
    }
    return data
      .filter((x) => x[mapKey])
      .reduce(
        (prev, entity) => {
          prev.data[entity[mapKey]] = entity;
          return prev;
        },
        { data: {}, loading },
      );
  }, [data, loading, mapKey]);
};

export const useUsersByOxygenIdMap = () => {
  return useEntitiesMap(useUsers, 'autodeskId');
};

export const useUsersByIdMap = () => {
  return useEntitiesMap(useUsers, 'id');
};

export const useFormTemplatesByUidMap = () => {
  return useEntitiesMap(
    useFormsContext,
    'uid',
    'formTemplates',
    'isLoadingFormTemplates',
  );
};

export const useUserPermissionsByPgIdMap = () =>
  useEntitiesMap(useUsersPermissionInfo, 'userPGID');

export const useCompaniesMapByMemberGroupId = () =>
  useEntitiesMap(useCompanies, 'memberGroupId');

export const useRolesMapByMemberGroupId = () =>
  useEntitiesMap(useRoles, 'memberGroupId');
